import { render } from "./TextArea.vue?vue&type=template&id=57b023b6&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=57b023b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-57b023b6"

export default script